<div class="wrapper">
  <div class="icon"></div>
  <ul *ngFor="let item of sidebars">
    <li [ngClass]="{ checked: item.checked }" class="side-bar-items">{{ item.title }}</li>
  </ul>
</div>
